export class User {
    constructor(userInfo?: any) {
        for (let key in userInfo) {
            switch (key.toLowerCase()) {
                case "email": this.Username = userInfo[key]; break;
                case "password": this.Password = userInfo[key]; break;
                case "firstname": this.FirstName = userInfo[key]; break;
                case "lastname": this.LastName = userInfo[key]; break;
                case "permission": this.Permission = userInfo[key]; break;
                case "access": this.Access = userInfo[key]; break;
                case "twofactorcode": this.TwoFactorCode = userInfo[key]; break;
            }
        }
    }
    Username: string;
    Email: string;
    Password: string;
    FirstName: string;
    LastName: string;
    Permission: number;
    Access: string;
    TwoFactorCode: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/User.ts